import * as React from 'react';
import GroupOptionsCheckbox from './GroupOptionsCheckbox';

import { Mutation } from 'react-apollo';
import SET_REQUEST_TO_JOIN from 'groups/components/mutations/setRequestToJoin.gql';
import ToastActions from 'actions/ToastActions';
import { ApolloError } from 'apollo-client';
import { setRequestToJoinVariables } from 'groups/components/mutations/__generated__/setRequestToJoin';

type Props = {
  checked: boolean;
  requestToJoinDefault: string;
  onChange: (e: React.MouseEvent, setRequestToJoin: Function) => void;
};

const GroupOptionsRequestToJoinCheckbox = (props: Props) => (
  <Mutation
    mutation={SET_REQUEST_TO_JOIN}
    onCompleted={() => ToastActions.showSuccessToast('Saved')}
    onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
    {(setRequestToJoin: (input: { variables: setRequestToJoinVariables }) => void) => (
      <GroupOptionsCheckbox
        label={'Require approval to join'}
        sublabel={
          'Only people who you add or approve will be able to join this class. Anyone added by your school will be approved automatically.'
        }
        checked={props.checked}
        schoolDefault={props.requestToJoinDefault}
        onChange={e => props.onChange(e, setRequestToJoin)}
      />
    )}
  </Mutation>
);

export default GroupOptionsRequestToJoinCheckbox;
